import { useLocalSearchParams, Stack } from 'expo-router';
import HomeGymSearch from '@/components/HomeGymSearch';

export default function ChangeHomeGymScreen() {
  const params = useLocalSearchParams<{ source?: string | string[] }>();
  const sourceParam = Array.isArray(params?.source) ? params.source[0] : params?.source;
  const isOnboarding = sourceParam === 'onboarding';

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <HomeGymSearch isOnboarding={isOnboarding} />
    </>
  );
}
